var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.402,
    cy: 32.783,
    r: 2.846,
    fill: "#423d9b",
    transform: "rotate(-37.16 57.424 32.788)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.402,
    cy: 32.783,
    r: 1.383,
    fill: "#211a67",
    transform: "rotate(-37.16 57.424 32.788)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f34b58",
    d: "m38.144 25.109-9.207 3.906-1.983-5.838a2.7 2.7 0 0 1-.146-1.061c.124-1.943 2.424-3.276 4.235-2.002z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e11226",
    d: "m38.144 25.109-9.207 3.906-1.983-5.838a2.7 2.7 0 0 1-.146-1.061s2.933 6.384 11.336 2.993"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#423d9b",
    d: "M26.035 51.284s5.964.372 9.812-1.65c1.672-.534.15-5.302-1.523-4.768z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#211a67",
    d: "M35.64 48.99c-.46.146-.964-.624-1.244-1.479-.288-.88-.34-1.848.134-2 .464-.148.971.635 1.25 1.497.283.875.331 1.83-.14 1.981"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9e7fc",
    d: "M18.98 33.824c5.637-2.899 35.629-17.896 41.322-11.87 1.253-.356 2.487-.363 3.565.096 1.824.775 2.58 3.08 1.437 4.699-4.179 5.91-27.808 14.91-53.513 15.948a2.84 2.84 0 0 1-2.449-1.236l-7.02-10.208a.97.97 0 0 1 .505-1.475l3.264-1.043a2.9 2.9 0 0 1 2.294.224l8.77 4.838a1.94 1.94 0 0 0 1.824.027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#cccff2",
    d: "M65.301 26.75c-4.18 5.909-27.81 14.909-53.51 15.95-.97.04-1.9-.43-2.45-1.24l-.89-1.301c47.02-1.84 56.17-17.65 56.17-17.65 1.26 1 1.66 2.87.68 4.24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#423d9b",
    d: "M33.413 44.216s5.965.372 9.812-1.65c1.673-.534.15-5.303-1.523-4.768z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.463,
    cy: 40.182,
    fill: "#211a67",
    rx: 0.736,
    ry: 1.825,
    transform: "rotate(-17.7 42.525 40.224)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f34b58",
    d: "M6.9 45.37a7 7 0 0 1-.354.106c-1.198.356-2.63.616-3.17.204-1.117-.857 3.615-4.707 5.65-5.989 1.517-.953 7.092-2.843 8.084-1.42.865 1.243-7.425 6.21-10.21 7.099"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#57b3fe",
    d: "M28.29 33.865a1.486 1.486 0 0 1-.922 1.888 1.486 1.486 0 0 1-1.886-.926c-.265-.773.148-1.616.924-1.882s1.619.147 1.884.92m5.238-2.025a1.486 1.486 0 0 1-.922 1.887 1.486 1.486 0 0 1-1.886-.926 1.48 1.48 0 0 1 .924-1.881 1.48 1.48 0 0 1 1.884.92m5.238-2.027c.265.777-.146 1.623-.922 1.888s-1.62-.15-1.886-.926c-.265-.773.148-1.615.924-1.881s1.619.147 1.884.92m5.238-2.026a1.486 1.486 0 0 1-.922 1.888 1.486 1.486 0 0 1-1.886-.926c-.265-.773.148-1.616.924-1.882s1.619.147 1.884.92m5.238-2.026a1.486 1.486 0 0 1-.922 1.888 1.486 1.486 0 0 1-1.886-.926 1.48 1.48 0 0 1 .924-1.882 1.48 1.48 0 0 1 1.884.92m11.06-3.809q-.514.404-.992.745l-.003.001c-4.834 3.437-7.203 2.362-7.024 1.081.058-.436.503-.925 1.08-1.385 1.224-.979 3.04-1.837 3.04-1.837l.006-.002c1.714.088 3.061.517 3.893 1.397"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#f34b58",
    d: "M44.115 34.458c1.077 2.82-17.037 17.103-22.91 19.543a7 7 0 0 1-.564.21c-2.331.746-5.097 1.014-6.565-.135-1.641-1.284 9.926-12.069 13.529-14.963 2.72-2.196 15.13-8.277 16.51-4.655"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#e11226",
    d: "M21.206 54a7 7 0 0 1-.565.212c-2.331.745-5.097 1.013-6.565-.136-1.641-1.284 9.926-12.069 13.529-14.963.314-.253.763-.56 1.31-.898 0 0-12.766 13.775-7.71 15.786M6.546 45.476c-1.198.356-2.63.616-3.17.204-1.117-.857 3.615-4.707 5.65-5.989 0 0-5.674 4.627-2.48 5.785"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.748 36.018c-.255.767-.625 1.483-1.04 2.168-1.206 1.977-3.059 3.973-5.177 4.912 1.823-1.959.514-.372 4.685-5.262.499-.606 1-1.213 1.532-1.818"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#5094ff",
    d: "M59.307 22.7c-4.834 3.436-7.203 2.36-7.024 1.08.058-.436.503-.925 1.08-1.385z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.575 30.703c2.057.616 5.245 2.407 6.838 3.849-1.646-.491-3.835-1.67-5.264-2.646a14 14 0 0 1-1.574-1.203m22.099-9.211c.815.285 1.648.806 2.34 1.282.638.45 1.474 1.145 1.982 1.784-.769-.267-1.7-.826-2.339-1.282-.678-.496-1.443-1.107-1.983-1.784"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9e7fc",
    d: "M2.73 16.726c6.196 2.785 19.629 1.895 21.26-.194 0 0 .805-.895-.319-1.436 0 0 2.102-1.665.32-3.593-1.568-1.707-2.92-.507-2.92-.507s.353-2.351-1.68-2.594c-2.49-.291-5.105 2.164-5.105 2.164s-2.56-1.838-5.3 1.686c0 0-2.67-.465-3.183 2.386-1.249.035-2.345.305-3.302.819-.59.312-.382.994.229 1.269M38.08 57.78c6.51 2.926 20.626 1.991 22.34-.204 0 0 .846-.94-.335-1.51 0 0 2.209-1.749.336-3.775-1.648-1.793-3.07-.532-3.07-.532s.373-2.471-1.763-2.727c-2.617-.306-5.365 2.275-5.365 2.275s-2.69-1.932-5.57 1.771c0 0-2.805-.488-3.345 2.508-1.312.036-2.464.32-3.47.86-.619.328-.4 1.045.241 1.334"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.88fb9184e2ae30af159ff8a1f032d62d.svg";
export { ForwardRef as ReactComponent };